"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutableComponentsManager = void 0;
var utils_1 = require("../RoutableContainer/utils");
var RoutableComponentsManager = /** @class */ (function () {
    function RoutableComponentsManager() {
        this.components = [];
    }
    RoutableComponentsManager.purge = function () {
        if (!RoutableComponentsManager.instance) {
            return;
        }
        RoutableComponentsManager.instance.components = [];
    };
    RoutableComponentsManager.getInstance = function () {
        if (!RoutableComponentsManager.instance) {
            RoutableComponentsManager.instance = new RoutableComponentsManager();
        }
        return RoutableComponentsManager.instance;
    };
    RoutableComponentsManager.prototype.registerComponent = function (route, ref, onDisplay, appendSlash) {
        route = utils_1.cleanSlashes(route);
        var index = this.components.findIndex(function (item) { return item.route === route || item.ref === ref; });
        var componentToRegister = {
            ref: ref,
            route: route,
            onDisplay: onDisplay,
            appendSlash: appendSlash,
            initialOffsetTop: ref.current ? utils_1.getTotalOffsetTop(ref.current) : NaN,
        };
        var components = this.components
            .slice(0)
            .map(function (c) {
            return __assign(__assign({}, c), { initialOffsetTop: c.ref.current ? utils_1.getTotalOffsetTop(c.ref.current) : NaN });
        });
        if (index >= 0) {
            // If this route is already registered, replace the existing metadata.
            components[index] = componentToRegister;
        }
        else {
            // If the route wasn't previously added.
            if (ref.current && ref.current.id === 'root') {
                components.unshift(componentToRegister);
            }
            else {
                components.push(componentToRegister);
            }
        }
        this.components = components
            .sort(function (a, b) { return a.initialOffsetTop - b.initialOffsetTop; })
            .map(function (c, i) { return (__assign(__assign({}, c), { position: i })); });
    };
    RoutableComponentsManager.prototype.deregisterComponent = function (route) {
        this.components = this.components.filter(function (item) { return item.route !== route; });
    };
    RoutableComponentsManager.prototype.getComponentByRoute = function (route) {
        route = utils_1.cleanSlashes(route);
        return this.components.find(function (i) { return i.route === route; });
    };
    return RoutableComponentsManager;
}());
exports.RoutableComponentsManager = RoutableComponentsManager;
//# sourceMappingURL=RoutableComponentsManager.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/routables/RoutableComponentsManager/RoutableComponentsManager.js
// module id = 999
// module chunks = 8